<template>
  <section class="content">
    <div class="box box-info">

    <div class="p-toolbar p-component mb-4">
    <bankaccountdialog ref="openDialog"/>
    </div>
    <bankDetailList @delete-message="deleteMessage" @edit-account="editBank"/>
  </div>
  </section>
</template>
<script>
import bankDetailList from './bankDetailList.vue'
import bankaccountdialog from '../accountDialog/BankAccountDialog.vue'

export default {
  name: 'bank',
  methods: {
    editBank(data) {
      this.$refs.openDialog.editBank(data)
    },
    deleteMessage(value) {
      this.$toast.add({severity: value.messageType, summary: '', detail: value.message, life: 10000})
    }
  },
  components: {
    bankDetailList,
    bankaccountdialog
  }
}
</script>



// WEBPACK FOOTER //
// BankDetail.vue?46627262